import ProductEditForm from "../Components/ProductEditForm.js"

function Edit(){

    return(
        <div>
             <h2>Edit</h2>
            <ProductEditForm />
        </div>
    )
}

export default Edit;